import "./articles.css";

import dayjs from "dayjs";
import React from "react";
import { Helmet } from "react-helmet";
import ReactMarkdown from "react-markdown";
import { Link, useParams } from "react-router-dom";

import { articles } from "../../articles";
import SocialShare from "../../components/SocialShare";
import { Button } from "../../components/ui/button";
import Layout from "./Layout";

function ArticleContent() {
	const { slug } = useParams();

	const data = React.useMemo(() => {
		return articles.filter((article) => article.slug === slug);
	}, [slug]);

	return (
		<>
			<Helmet>
				<title>{data[0].title} | Dproz</title>
				<meta name="description" content={data[0].excerpt.replace(/<[^>]+>/g, "")} />
				<meta property="og:title" content={data[0].title} />
				<meta property="og:description" content={data[0].excerpt.replace(/<[^>]+>/g, "")} />
				<meta property="og:type" content="article" />
				<meta property="og:url" content={`https://dproz.com/articles/${data[0].slug}`} />
				<meta property="og:image:alt" content={data[0].title} />
				<meta property="og:site_name" content="Dproz" />
			</Helmet>
			<Layout>
				<section className="max-w-5xl mx-auto px-4 md:px-8 py-16 bg-white">
					<div className="mb-8">
						<ul className="flex items-center space-x-2 text-gray-500">
							<li>
								<Link to="/articles">Articles</Link>
							</li>
							<li className="text-gray-400">/</li>
							<li className="text-gray-700">{data[0].title}</li>
						</ul>
					</div>

					<div className="flex items-center justify-end mb-3">
						{data[0].date && (
							<span className="text-sm text-gray-500 mr-auto">
								Published on {dayjs(data[0].date).format("MMMM D, YYYY")}
							</span>
						)}
						<SocialShare message={data[0].title} />
					</div>
					<div className="article-content">
						<ReactMarkdown>{data[0].content}</ReactMarkdown>
					</div>

					<div className="rounded bg-primary-800 text-white mt-12">
						<div className="max-w-5xl mx-auto px-4 md:px-8 gap-8 py-8 flex flex-col md:flex-row items-center justify-between">
							<div className="flex items-center gap-2">
								<img src="/images/featured-company.png" className="h-32" alt="people sitting together at a desk" />
								<div className="mb-4 md:mb-0 text-center md:text-left">
									<h2 className="text-2xl font-bold mb-2 text-white">Enjoyed this article?</h2>
									<p className="text-lg">Join Dproz today and take the next step in your career!</p>
								</div>
							</div>
							<Link to="/register">
								<Button variant="secondary">Get Started</Button>
							</Link>
						</div>
					</div>
				</section>
			</Layout>
		</>
	);
}

export default ArticleContent;
